export const COMPANY_SIGNUP_LEADACTION = {
  SIGNUP: 'COMPANY_SIGNUP_LEADACTION_SIGNUP',
}
